import { STATUS_LABELS } from "../phone_statuses.config";

/** Возвращает стандартные HTTP-заголовки для JSON-запросов
 * @returns {{ "X-CSRF-Token": string, "Content-Type": string }}
 */
function jsonHeaders() {
  return {
    "X-CSRF-Token": getMeta("csrf-token"),
    "Content-Type": "application/json",
  };
}

/** Запрос на проверку возможности изменения статуса телефона
 * @param {(number|string)[]} phoneIds - Список ID телефонов
 * @param {string | number} status - Новый статус
 * @returns {Promise<Object>}
 */
export async function checkPhonesStatus(phoneIds, status) {
  const response = await fetch("/free_phones/bulk_check_status", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({
      phone_ids: JSON.stringify(phoneIds),
      status,
    }),
  });

  return response.json();
}

/** Запрос на обновление статуса телефона
 * @param {number | string} id - ID телефона
 * @param {string | number} status - Новый статус
 * @returns {Promise<Response>}
 */
export async function updatePhoneStatus(id, status) {
  const response = await fetch(`/free_phones/${id}`, {
    method: "PATCH",
    headers: jsonHeaders(),
    body: JSON.stringify({ status }),
  });

  return response;
}

/** Запрос на обновление статуса выбранных телефонов
 * @param {(number|string)[]} phoneIds - Список ID телефонов
 * @param {string | number} status - Новый статус
 * @returns {Promise<Object>}
 */
export async function bulkUpdatePhoneStatus(phoneIds, status) {
  const response = await fetch("/free_phones/bulk_update_status", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({
      phone_ids: JSON.stringify(phoneIds),
      status,
    }),
  });

  return response.json();
}

/** Запрос на подключение выбранных телефонов
 * @param {Object} data - Данные подключения
 * @param {Object[]} data.phonesRecords - Список телефонов для подключения
 * @param {string} data.email - Email пользователя
 * @param {number|string} data.project_id - ID проекта
 * @returns {Promise<Object>}
 */
export async function bulkConnectPhones(data) {
  const response = await fetch("/free_phones/bulk_connect", {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({
      phones_records: data.phonesRecords,
      user_email: data.email,
      project_id: Number(data.project_id),
    }),
  });

  return response.json();
}

/** Запрос на получение списка проектов пользователя для подключения телефонов
 * @param {string} email - Email пользователя
 * @returns {Promise<Response>}
 */
export async function getProjectsForBulkConnect(email) {
  const response = await fetch(`/free_phones/user_projects?email=${email}`, {
    method: "GET",
    headers: jsonHeaders(),
  });

  return response;
}
